export default "<p-sidebar [(visible)]=\"display\" (onHide)=\"toggleStatus(false)\">\n  <h1>MENU</h1>\n  <app-menu></app-menu>\n</p-sidebar>\n"